import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['../admin-layout.component.scss'],
})
export class DevicesComponent {}
